import type { CustomizeGridContent } from "../types";

export const customizeGrid: CustomizeGridContent = {
  title: "Built for sensitive research data.",
  lead:
    "The controls that made UCloud the national platform for sensitive " +
    "research data, now wrapped around every inference call.",
  cards: [
    {
      title: "Governance by default",
      body: "ISO/IEC 27001:2022 certified and approved for sensitive data. Project roles, quotas, and access stay under your control, and your university's.",
    },
    {
      title: "Research files, connected",
      body: "Run models directly against the data already in your UCloud project. Datasets, transcripts, and documents never leave the project to reach a model.",
    },
    {
      title: "Danish residency, by default",
      body: "Your data stays in Denmark and is never used for model training, not for anyone's models. Every request is processed on national infrastructure under Danish law.",
    },
  ],
};
